import { useState, useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import { SelectChangeEvent } from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { getAllServices } from "../services/API/services";
import { setServiseData } from "@/store/service/service";

export default function useServices() {
    const dispatch = useDispatch();
    const [query, setQuery] = useState("");
    const [category, setCategory] = useState("Всі категорії");
    const [isLoading, setIsLoading] = useState(false);
    const unfilteredData = useSelector(
        (state: RootState) => state.services.serviceData,
    );

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setQuery(e.target.value);
    };

    const handleChangeCategory = (event: SelectChangeEvent) => {
        setCategory(event.target.value);
    };

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            const response = await getAllServices();
            if (response && response?.data) {
                dispatch(setServiseData(response.data));
            } else {
                toast.error(response?.error || "Не вдалося отримати дані");
            }

            setIsLoading(false);
        }
        fetchData();
    }, [dispatch]);

    const filteredData = useMemo(() => {
        let filtered = [...unfilteredData];

        if (category !== "Всі категорії") {
            filtered = filtered.filter(
                item =>
                    typeof item.category === "string" &&
                    item.category.toLowerCase().trim() ===
                        category.toLowerCase().trim(),
            );
        }

        const trimmedQuery = query.trim();

        if (trimmedQuery) {
            const isNumeric = !isNaN(Number(trimmedQuery));

            if (isNumeric) {
                filtered = filtered.filter(item =>
                    String(item.code).includes(trimmedQuery),
                );
            } else {
                filtered = filtered.filter(
                    item =>
                        typeof item.title === "string" &&
                        item.title
                            .toLowerCase()
                            .includes(trimmedQuery.toLowerCase()),
                );
            }
        }

        return filtered;
    }, [unfilteredData, query, category]);

    return {
        data: filteredData,
        handleChange,
        handleChangeCategory,
        query,
        category,
        dataLength: filteredData.length,
        isLoading,
    };
}
